import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Platform18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.62788 0.348818C8.85846 0.217061 9.14152 0.217061 9.37209 0.348818L16.3721 4.34882C16.8667 4.63143 16.8667 5.36857 16.3721 5.65118L14.0117 7L16.3721 8.34882C16.8667 8.63143 16.8667 9.36857 16.3721 9.65118L14.0117 11L16.3721 12.3488C16.8667 12.6314 16.8667 13.3686 16.3721 13.6512L9.37209 17.6512C9.14152 17.7829 8.85846 17.7829 8.62788 17.6512L1.62788 13.6512C1.13332 13.3686 1.13332 12.6314 1.62788 12.3488L3.98831 11L1.62788 9.65118C1.13332 9.36857 1.13332 8.63143 1.62788 8.34882L3.98831 7L1.62788 5.65118C1.13332 5.36857 1.13332 4.63143 1.62788 4.34882L8.62788 0.348818ZM5.49999 11.8638L3.51166 13L8.99999 16.1362L14.4883 13L12.5 11.8638L9.37209 13.6512C9.14152 13.7829 8.85846 13.7829 8.62788 13.6512L5.49999 11.8638ZM9.37209 9.65118L12.5 7.86381L14.4883 9L8.99999 12.1362L3.51166 9L5.49999 7.86381L8.62788 9.65118C8.85846 9.78294 9.14152 9.78294 9.37209 9.65118ZM3.51166 5L8.99999 8.13619L14.4883 5L8.99999 1.86381L3.51166 5Z'
      fill='currentColor'
    />
  </Svg>
);

Platform18.displayName = 'Platform18';
export default Platform18;
